import { configureStore } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import { combineReducers } from "redux";
// import favoriteRducer from "./Favorite";
// import messagesRducer from "./Message";
import authRducer from "./auth";
import productsRducer from "./product";
import categoriesducer from "./categories";
import layoutRducer from "./layout";
 import localizationReducer from "./Localization";
 import cartReducer from "./cart";

// import usersRducer from "./users";
import storage from "redux-persist/lib/storage"; // ✅ دي اللي بتشتغل على الويب (localStorage)

const persistConfig = {
    key: "root",
    version: 1,
    storage: storage,
    
};

const RootReducers = combineReducers({
   auth: authRducer,
   productsRducer,
   categoriesducer,
   layoutRducer,
   currentLocal: localizationReducer,
cartReducer:cartReducer
    // messages: messagesRducer,
    // users: usersRducer,
    // user: userRducer,




});

const persistedReducer = persistReducer(persistConfig, RootReducers);

export default configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});